import { jsx as e, jsxs as l, Fragment as m } from "react/jsx-runtime";
import * as z from "react";
import b, { useState as I, useEffect as j, useRef as v } from "react";
import { ChevronsUpDown as V, LogOut as U, MoreHorizontal as _, House as q, ChevronsUp as K, ChevronsLeft as W, ChevronsRight as J, ChevronsDown as Q, Save as X, ArrowLeft as Y } from "lucide-react";
import { D as Z, a as $, A as M, b as A, c as P, d as ee, e as ae, f as le, g as te, S as re, h as ie, i as se, j as ne, k as T, T as ce, l as de, m as C, n as oe, o as he, p as me, R as D, q as p, r as x } from "./resizable-a59df3c1.js";
import { u as F, d as k, e as B, f as O, P as ue, a as fe, B as S, b as pe, S as w, c as R, g as y, h as H, i as E, j as ge, k as Ne, l as be, m as ve, n as xe } from "./sidebar-59b82a61.js";
import { u as L } from "./use-layout-167c9584.js";
import { P as d } from "./panel-position-9ca63a49.js";
import { N as we } from "./nav-actions-34ecafa5.js";
import { ThemeProvider as Se } from "./components.js";
import { u as Te } from "./use-app-2875a38b.js";
import { useLocation as Ce, useHistory as ye, Route as ze } from "react-router-dom";
import "react-dom";
import "clsx";
import "./use-mobile-b816b6c7.js";
import "tailwind-merge";
function Ie({
  user: t
}) {
  const { isMobile: i } = F();
  return /* @__PURE__ */ e(k, { children: /* @__PURE__ */ e(B, { children: /* @__PURE__ */ l(Z, { children: [
    /* @__PURE__ */ e($, { asChild: !0, children: /* @__PURE__ */ l(
      O,
      {
        size: "lg",
        className: "data-[state=open]:bg-sidebar-accent data-[state=open]:text-sidebar-accent-foreground md:h-8 md:p-0",
        children: [
          /* @__PURE__ */ l(M, { className: "h-8 w-8 rounded-lg", children: [
            /* @__PURE__ */ e(A, { src: t.avatar, alt: t.name }),
            /* @__PURE__ */ e(P, { className: "rounded-lg", children: "CN" })
          ] }),
          /* @__PURE__ */ l("div", { className: "grid flex-1 text-left text-sm leading-tight", children: [
            /* @__PURE__ */ e("span", { className: "truncate font-semibold", children: t.name }),
            /* @__PURE__ */ e("span", { className: "truncate text-xs", children: t.email })
          ] }),
          /* @__PURE__ */ e(V, { className: "ml-auto size-4" })
        ]
      }
    ) }),
    /* @__PURE__ */ l(
      ee,
      {
        className: "w-[--radix-dropdown-menu-trigger-width] min-w-56 rounded-lg",
        side: i ? "bottom" : "right",
        align: "end",
        sideOffset: 4,
        children: [
          /* @__PURE__ */ e(ae, { className: "p-0 font-normal", children: /* @__PURE__ */ l("div", { className: "flex items-center gap-2 px-1 py-1.5 text-left text-sm", children: [
            /* @__PURE__ */ l(M, { className: "h-8 w-8 rounded-lg", children: [
              /* @__PURE__ */ e(A, { src: t.avatar, alt: t.name }),
              /* @__PURE__ */ e(P, { className: "rounded-lg", children: "CN" })
            ] }),
            /* @__PURE__ */ l("div", { className: "grid flex-1 text-left text-sm leading-tight", children: [
              /* @__PURE__ */ e("span", { className: "truncate font-semibold", children: t.name }),
              /* @__PURE__ */ e("span", { className: "truncate text-xs", children: t.email })
            ] })
          ] }) }),
          /* @__PURE__ */ e(le, {}),
          /* @__PURE__ */ l(te, { children: [
            /* @__PURE__ */ e(U, {}),
            "TOWNへ戻る"
          ] })
        ]
      }
    )
  ] }) }) });
}
function ke({ sideActionItems: t }) {
  const [i, s] = z.useState(!1);
  return z.useEffect(() => {
    s(!1);
  }, []), t ? /* @__PURE__ */ e("div", { className: "flex items-center gap-2 text-sm", children: /* @__PURE__ */ l(ue, { open: i, onOpenChange: s, children: [
    /* @__PURE__ */ e(fe, { asChild: !0, children: /* @__PURE__ */ e(
      S,
      {
        variant: "ghost",
        size: "icon",
        className: "h-7 w-7 data-[state=open]:bg-accent",
        children: /* @__PURE__ */ e(_, {})
      }
    ) }),
    /* @__PURE__ */ e(
      pe,
      {
        className: "w-56 overflow-hidden rounded-lg p-0",
        align: "end",
        children: /* @__PURE__ */ e(w, { collapsible: "none", className: "bg-transparent", children: /* @__PURE__ */ e(R, { children: t }) })
      }
    )
  ] }) }) : /* @__PURE__ */ e(m, {});
}
function Be({ ...t }) {
  var n, u;
  const { sideNav: i, sideUser: s } = L(), [r, o] = z.useState(i[0]), { setOpen: a } = F();
  return /* @__PURE__ */ l(
    w,
    {
      collapsible: "icon",
      className: "overflow-hidden [&>[data-sidebar=sidebar]]:flex-row",
      ...t,
      children: [
        /* @__PURE__ */ l(
          w,
          {
            collapsible: "none",
            className: "!w-[calc(var(--sidebar-width-icon)_+_1px)] border-r",
            children: [
              /* @__PURE__ */ e(y, { children: /* @__PURE__ */ e(k, { children: /* @__PURE__ */ e(B, { children: /* @__PURE__ */ e(O, { size: "lg", asChild: !0, className: "md:h-8 md:p-0", children: /* @__PURE__ */ l("a", { href: "#", children: [
                /* @__PURE__ */ e("div", { className: "flex aspect-square size-8 items-center justify-center rounded-lg bg-sidebar-primary text-sidebar-primary-foreground", children: /* @__PURE__ */ e(q, { className: "size-4" }) }),
                /* @__PURE__ */ l("div", { className: "grid flex-1 text-left text-sm leading-tight", children: [
                  /* @__PURE__ */ e("span", { className: "truncate font-semibold", children: "Acme Inc" }),
                  /* @__PURE__ */ e("span", { className: "truncate text-xs", children: "Enterprise" })
                ] })
              ] }) }) }) }) }),
              /* @__PURE__ */ e(R, { children: /* @__PURE__ */ e(H, { children: /* @__PURE__ */ e(E, { className: "px-1.5 md:px-0", children: /* @__PURE__ */ e(k, { children: i.map((c) => /* @__PURE__ */ e(B, { children: /* @__PURE__ */ l(
                O,
                {
                  tooltip: {
                    children: c.title,
                    hidden: !1
                  },
                  onClick: () => {
                    o(c), a(!0);
                  },
                  isActive: r.title === c.title,
                  className: "px-2.5 md:px-2",
                  children: [
                    /* @__PURE__ */ e(c.icon, {}),
                    /* @__PURE__ */ e("span", { children: c.title })
                  ]
                }
              ) }, c.title)) }) }) }) }),
              /* @__PURE__ */ e(ge, { children: /* @__PURE__ */ e(Ie, { user: s }) })
            ]
          }
        ),
        /* @__PURE__ */ l(w, { collapsible: "none", className: "hidden flex-1 md:flex", children: [
          /* @__PURE__ */ e(y, { className: "gap-3.5 border-b p-2", children: /* @__PURE__ */ l("div", { className: "flex w-full h-10 items-center justify-between", children: [
            /* @__PURE__ */ e("div", { className: "text-sm font-medium text-foreground truncate", children: "鹿児島県徳之島町" }),
            /* @__PURE__ */ l(re, { children: [
              /* @__PURE__ */ e(ie, { className: "w-[120px] h-8", children: /* @__PURE__ */ e(se, { placeholder: "年度" }) }),
              /* @__PURE__ */ l(ne, { children: [
                /* @__PURE__ */ e(T, { value: "light", children: "令和4年度" }),
                /* @__PURE__ */ e(T, { value: "dark", children: "令和5年度" }),
                /* @__PURE__ */ e(T, { value: "system", children: "令和16年度" })
              ] })
            ] })
          ] }) }),
          /* @__PURE__ */ e(y, { className: "gap-3.5 border-b p-2", children: /* @__PURE__ */ l("div", { className: "flex w-full h-4 items-center justify-between", children: [
            /* @__PURE__ */ e("div", { className: "text-sm font-medium text-foreground truncate", children: r.title }),
            /* @__PURE__ */ e(
              ke,
              {
                sideActionItems: (n = i.find((c) => r.id === c.id)) == null ? void 0 : n.sideActions
              }
            )
          ] }) }),
          /* @__PURE__ */ e(R, { children: /* @__PURE__ */ e(H, { className: "p-1", children: /* @__PURE__ */ e(E, { children: (u = i.find((c) => r.id === c.id)) == null ? void 0 : u.component }) }) })
        ] })
      ]
    }
  );
}
function We({
  title: t = "",
  isSave: i = !1,
  formID: s = "",
  position: r = d.NONE,
  params: o = null
}) {
  const { collapsed: a, setCollapsed: n } = L(), u = () => {
    r === d.TOP ? n({ ...a, isTop: !a.isTop }) : r === d.LEFT ? n({ ...a, isLeft: !a.isLeft }) : r === d.RIGHT ? n({ ...a, isRight: !a.isRight }) : r === d.BOTTOM && n({ ...a, isBottom: !a.isBottom });
  };
  return /* @__PURE__ */ e(m, { children: /* @__PURE__ */ l("header", { className: "flex h-12 shrink-0 items-center gap-2 border-b w-full", children: [
    /* @__PURE__ */ l("div", { className: "flex flex-1 items-center gap-2 px-3 truncate", children: [
      r !== d.MAIN && /* @__PURE__ */ l(
        S,
        {
          variant: "ghost",
          size: "icon",
          className: "h-7 w-7",
          onClick: u,
          children: [
            r === d.TOP ? /* @__PURE__ */ e(K, {}) : r === d.LEFT ? /* @__PURE__ */ e(W, {}) : r === d.RIGHT ? /* @__PURE__ */ e(J, {}) : r === d.BOTTOM ? /* @__PURE__ */ e(Q, {}) : /* @__PURE__ */ e(m, {}),
            /* @__PURE__ */ e("span", { className: "sr-only", children: "back button" })
          ]
        }
      ),
      /* @__PURE__ */ e("h4", { className: "scroll-m-20 text-base font-semibold tracking-tight truncate", children: /* @__PURE__ */ e("p", { className: "truncate", children: t }) })
    ] }),
    i && /* @__PURE__ */ e("div", { className: "ml-auto px-3", children: /* @__PURE__ */ l(S, { type: "submit", form: s, children: [
      /* @__PURE__ */ e(X, {}),
      "保存"
    ] }) })
  ] }) });
}
function N({
  contents: t,
  position: i
}) {
  const [s, r] = I(t && t[0].id), o = (a) => {
    r(a);
  };
  if (!t)
    return /* @__PURE__ */ e(m, {});
  if (t.length > 1)
    return /* @__PURE__ */ l(
      ce,
      {
        defaultValue: t[0].id,
        onValueChange: o,
        className: "flex flex-col h-full w-full",
        children: [
          /* @__PURE__ */ e(de, { className: "h-9 justify-start", children: /* @__PURE__ */ l(C, { className: "w-full whitespace-nowrap rounded-md border", children: [
            t.map((a, n) => /* @__PURE__ */ e(oe, { value: a.id, children: a.tabTitle })),
            /* @__PURE__ */ e(he, { orientation: "horizontal" })
          ] }) }),
          /* @__PURE__ */ e("div", { className: "h-12 m-0", children: (() => {
            const a = t.find((n) => n.id === s);
            return a ? b.createElement(a.header.element, {
              title: a.header.title,
              isSave: a.header.isSave,
              formID: a.id,
              position: i,
              params: a.header.params
            }) : /* @__PURE__ */ e(m, {});
          })() }),
          /* @__PURE__ */ e("div", { className: "h-[calc(100%-48px-36px)] m-0", children: t.map((a, n) => (
            // <TabsContent value={content.id} className="m-0">
            /* @__PURE__ */ e(me, { value: a.id, className: "h-full m-0", children: /* @__PURE__ */ e(C, { className: "h-full m-0", children: /* @__PURE__ */ e("div", { className: "p-1", children: b.createElement(a.content.element, {
              formID: a.id,
              params: a.content.params
            }) }) }) })
          )) })
        ]
      }
    );
  if (t.length === 1) {
    const a = t[0];
    return /* @__PURE__ */ e(m, { children: /* @__PURE__ */ l("div", { className: "flex flex-col h-full w-full", children: [
      /* @__PURE__ */ e("div", { className: "h-12 m-0", children: b.createElement(a.header.element, {
        title: a.header.title,
        isSave: a.header.isSave,
        formID: a.id,
        position: i,
        params: a.header.params
      }) }),
      /* @__PURE__ */ e(C, { className: "h-full m-0", children: /* @__PURE__ */ e("div", { className: "p-1", children: b.createElement(a.content.element, {
        formID: a.id,
        params: a.content.params
      }) }) })
    ] }) });
  }
}
function Oe() {
  const t = Te(), i = Ce(), [s, r] = I(""), [o, a] = I(!1), n = ye();
  return j(() => {
    if (t) {
      let u = "", c = !1;
      const f = t.getRoutes;
      f.sort((h, g) => g.pathname.length - h.pathname.length);
      for (let h = 0; h < f.length; h++) {
        const g = i.pathname.replace("/", ""), G = f[h].pathname.replace("/", "");
        if (g.indexOf(G) > -1) {
          u = f[h].title, c = f[h].isBack;
          break;
        }
      }
      r(u), a(c);
    }
  }, [i.pathname]), // <Breadcrumb>
  //   <BreadcrumbList>
  //     <BreadcrumbItem className="hidden md:block">
  //       <BreadcrumbLink href="#">components</BreadcrumbLink>
  //     </BreadcrumbItem>
  //     <BreadcrumbSeparator className="hidden md:block" />
  //     <BreadcrumbItem className="hidden md:block">
  //       <BreadcrumbLink href="#">ui</BreadcrumbLink>
  //     </BreadcrumbItem>
  //     <BreadcrumbSeparator className="hidden md:block" />
  //     <BreadcrumbItem>
  //       <BreadcrumbPage>button.tsx</BreadcrumbPage>
  //     </BreadcrumbItem>
  //   </BreadcrumbList>
  // </Breadcrumb>
  /* @__PURE__ */ l(m, { children: [
    o && /* @__PURE__ */ l(
      S,
      {
        variant: "ghost",
        size: "icon",
        className: "h-7 w-7",
        onClick: () => n.goBack(),
        children: [
          /* @__PURE__ */ e(Y, {}),
          /* @__PURE__ */ e("span", { className: "sr-only", children: "back button" })
        ]
      }
    ),
    /* @__PURE__ */ e("h4", { className: "scroll-m-20 text-base font-semibold tracking-tight truncate", children: /* @__PURE__ */ e("p", { className: "truncate", children: s }) })
  ] });
}
function Re({ router: t }) {
  const {
    mainContents: i,
    topContents: s,
    bottomContents: r,
    leftContents: o,
    rightContents: a
  } = t, n = v(null), u = v(null), c = v(null), f = v(null), { collapsed: h, setCollapsed: g } = L();
  return j(() => {
    g({
      isTop: !(s && (s == null ? void 0 : s.length) > 0),
      isBottom: !(r && (r == null ? void 0 : r.length) > 0),
      isLeft: !(o && (o == null ? void 0 : o.length) > 0),
      isRight: !(a && (a == null ? void 0 : a.length) > 0)
    });
  }, []), /* @__PURE__ */ l(D, { direction: "horizontal", className: "h-full w-full", children: [
    o && o.length > 0 && !h.isLeft && /* @__PURE__ */ l(m, { children: [
      /* @__PURE__ */ e(p, { defaultSize: 25, collapsible: !0, order: 1, ref: n, children: /* @__PURE__ */ e(
        N,
        {
          contents: o,
          position: d.LEFT
        }
      ) }),
      /* @__PURE__ */ e(x, { withHandle: !0 })
    ] }),
    /* @__PURE__ */ e(p, { defaultSize: 50, order: 2, children: /* @__PURE__ */ l(D, { direction: "vertical", children: [
      s && s.length > 0 && !h.isTop && /* @__PURE__ */ l(m, { children: [
        /* @__PURE__ */ e(
          p,
          {
            defaultSize: 25,
            collapsible: !0,
            order: 4,
            ref: c,
            children: /* @__PURE__ */ e(
              N,
              {
                contents: s,
                position: d.TOP
              }
            )
          }
        ),
        /* @__PURE__ */ e(x, { withHandle: !0 })
      ] }),
      /* @__PURE__ */ e(p, { defaultSize: 50, order: 5, children: /* @__PURE__ */ e(
        N,
        {
          contents: i,
          position: d.MAIN
        }
      ) }),
      r && r.length > 0 && !h.isBottom && /* @__PURE__ */ l(m, { children: [
        /* @__PURE__ */ e(x, { withHandle: !0 }),
        /* @__PURE__ */ e(
          p,
          {
            defaultSize: 25,
            collapsible: !0,
            order: 6,
            ref: f,
            children: /* @__PURE__ */ e(
              N,
              {
                contents: r,
                position: d.BOTTOM
              }
            )
          }
        )
      ] })
    ] }) }),
    a && a.length > 0 && !h.isRight && /* @__PURE__ */ l(m, { children: [
      /* @__PURE__ */ e(x, { withHandle: !0 }),
      /* @__PURE__ */ e(p, { defaultSize: 25, collapsible: !0, order: 3, ref: u, children: /* @__PURE__ */ e(
        N,
        {
          contents: a,
          position: d.RIGHT
        }
      ) })
    ] })
  ] });
}
function Je({
  routers: t
}) {
  return /* @__PURE__ */ e(Se, { defaultTheme: "light", storageKey: "vite-ui-theme", children: /* @__PURE__ */ l(
    Ne,
    {
      style: {
        "--sidebar-width": "20rem",
        "--sidebar-width-mobile": "20rem"
      },
      children: [
        /* @__PURE__ */ e(Be, {}),
        /* @__PURE__ */ l(be, { children: [
          /* @__PURE__ */ l("header", { className: "flex h-10 shrink-0 items-center gap-2 border-b", children: [
            /* @__PURE__ */ l("div", { className: "flex flex-1 items-center gap-2 px-3", children: [
              /* @__PURE__ */ e(ve, {}),
              /* @__PURE__ */ e(xe, { orientation: "vertical", className: "mr-2 h-4" }),
              /* @__PURE__ */ e(Oe, {})
            ] }),
            /* @__PURE__ */ e("div", { className: "ml-auto px-3", children: /* @__PURE__ */ e(we, {}) })
          ] }),
          /* @__PURE__ */ e("main", { className: "h-full w-full", children: t.map((i, s) => /* @__PURE__ */ e(ze, { exact: !0, path: i.path, children: /* @__PURE__ */ e(Re, { router: i }) }, s)) })
        ] })
      ]
    }
  ) });
}
export {
  Be as AppSidebar,
  We as ContentsHeader,
  N as ContentsPanel,
  Je as Layout,
  Re as LayoutMain,
  we as NavActions,
  Oe as NavBreadcrumb,
  Ie as NavUser,
  ke as SideActions
};
